<template>
  <div class="grey lighten-5 fill-height">
    <EditResetPassword />
    <toaster />
  </div>
</template>
<script>
import EditResetPassword from '/src/components/pages/ResetPassword/edit'
import Toaster from '@/components/commons/Toaster'

export default {
  components: { EditResetPassword, Toaster }
}
</script>
